import * as React from "react";
import Paper from "@mui/material/Paper";
import { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Divider,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import HOST_URL from "../../../utils/Url";
import { useLocation } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import { usePermissionData } from "../../../usePermissionData";
import DeleteIcon from "@mui/icons-material/Delete";
import { secureGetItem } from "../../../utils/encryption";

interface MenuPermission {
  isAdd: boolean;
  isEdit: boolean;
  isPrint: boolean;
  isDel: boolean;
}

export default function DocSubSubject() {
  const { i18n, t } = useTranslation();
  const [columns, setColumns] = useState<any>([]);
  const [rows, setRows] = useState<any>([]);
  const [editId, setEditId] = useState(-1);
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [permissionLoaded, setPermissionLoaded] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [permissionData, setPermissionData] = useState<MenuPermission>({
    isAdd: false,
    isEdit: false,
    isPrint: false,
    isDel: false,
  });

  const [SubjectOption, setSubjectOption] = useState([
    { value: -1, label: t("text.SelectSubject") },
  ]);

  useEffect(() => {
    const data = secureGetItem("userdata");

    if (data && data.length > 0) {
      const userPermissionData = data[0]?.userPermission;
      const menudata = userPermissionData?.[0]?.parentMenu || [];

      for (let i = 0; i < menudata.length; i++) {
        const childMenudata = menudata[i]?.childMenu || [];
        const pathrow = childMenudata.find(
          (x: any) => x.path === location.pathname
        );

        if (pathrow) {
          setPermissionData({
            isAdd: pathrow.isAdd,
            isEdit: pathrow.isEdit,
            isPrint: pathrow.isPrint,
            isDel: pathrow.isDel,
          });
          break;
        }
      }
    }
    setPermissionLoaded(true);
  }, [location.pathname]);

  // Agar add permission ho to form show karo
  useEffect(() => {
    if (permissionLoaded && permissionData?.isAdd) {
      setShowForm(true);
      setIsEdit(false);
      formik.resetForm();
    } else {
      setShowForm(false);
    }
  }, [permissionData?.isAdd, permissionLoaded]);

  useEffect(() => {
    if (permissionLoaded) {
      getList();
      getSubject();
    }
  }, [permissionLoaded]);

  const getSubject = () => {
    const collectData = {
      sId: -1,
    };
    axios
      .post(
        HOST_URL.HOST_URL2 + `SubjectMasterForPdf/GetSubjectMasterForPdf`,
        collectData
      )
      .then((res) => {
        const arr = res.data.data.map((item: any) => ({
          label: item.subject,
          value: item.sId,
        }));
        setSubjectOption(arr);
      });
  };

  let delete_id = "";
  const accept = () => {
    const collectData = {
      sSubId: delete_id,
    };
    console.log("collectData " + JSON.stringify(collectData));
    axios
      .post(HOST_URL.HOST_URL2 + `SubSubjForPdf/DeleteSubSubjForPdf`, 
       collectData
      )
      .then((response) => {
        if (response.data.isSuccess) {
          toast.success(response.data.mesg);
        } else {
          toast.error(response.data.mesg);
        }
        getList();
      });
  };
  const reject = () => {
    toast.warn("Rejected: You have rejected", { autoClose: 3000 });
  };

  const handledeleteClick = (del_id: any) => {
    if (!permissionData?.isDel) {
      toast.error("You don't have delete permission");
      return;
    }
    delete_id = del_id;
    confirmDialog({
      message: "Do you want to delete this record ?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p=-button-danger",
      accept,
      reject,
    });
  };

  const getList = () => {
    const collectData = {
      sSubId: -1,
    };
    try {
      axios
        .post(
          HOST_URL.HOST_URL2 + `SubSubjForPdf/GetSubSubjForPdf`,
          collectData
        )
        .then((res) => {
          console.log("result" + JSON.stringify(res.data.data));
          const data = res.data.data;
          const arr = data.map((item: any, index: any) => ({
            ...item,
            serialNo: index + 1,
            id: item.sSubId,
          }));
          setRows(arr);
          setIsLoading(false);
          
          const actionColumn: GridColDef[] =
            permissionData?.isEdit || permissionData?.isDel
              ? [
                  {
                    field: "actions",
                    headerClassName: "MuiDataGrid-colCell",
                    headerName: t("text.Action"),
                    width: 150,
                    renderCell: (params) => (
                      <Stack spacing={1} direction="row" sx={{ alignItems: "center", marginTop: "5px" }}>
                        {permissionData?.isEdit && (
                          <EditIcon
                            style={{
                              fontSize: "20px",
                              color: "blue",
                              cursor: "pointer",
                            }}
                            className="cursor-pointer"
                            onClick={() => routeChangeEdit(params.row)}
                          />
                        )}
                        {permissionData?.isDel && (
                          <DeleteIcon
                            style={{
                              fontSize: "20px",
                              color: "red",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handledeleteClick(params.row.id);
                            }}
                          />
                        )}
                      </Stack>
                    ),
                  },
                ]
              : [];

          const columns: GridColDef[] = [
            ...actionColumn,
            {
              field: "serialNo",
              headerName: t("text.SrNo"),
              flex: 1,
              headerClassName: "MuiDataGrid-colCell",
              minWidth: 60
            },
            {
              field: "mainSub_Name",
              headerName: t("text.Subject"),
              flex: 1,
              headerClassName: "MuiDataGrid-colCell",
              minWidth: 150
            },
            {
              field: "subSubj",
              headerName: t("text.SubSubject"),
              flex: 1,
              headerClassName: "MuiDataGrid-colCell",
              minWidth: 200
            },
          ];
          setColumns(columns as any);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  
  const validationSchema = Yup.object({
    subSubj: Yup.string().test(
      "required",
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),
    mainSubid: Yup.number().test(
      "required",
      function (value: any) {
        return value && value !== -1;
      }
    ),
  });
  
  const [toaster, setToaster] = useState(false);
  const formik = useFormik({
    initialValues: {
      sSubId: -1,
      subSubj: "",
      userID: "",
      mainSubid: -1,
      mainSub_Name: "",
      srn: 0,
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      values.sSubId = editId;

      const response = await axios.post(
        HOST_URL.HOST_URL2 + `SubSubjForPdf/AddUpdateSubSubjForPdf`,
        values
      );
      if (response.data.isSuccess) {
        setToaster(false);
        toast.success(response.data.mesg);
        formik.resetForm();
        setIsEdit(false);
        if (!permissionData?.isAdd) {
          setShowForm(false);
        }
        setEditId(-1);
        getList();
      } else {
        setToaster(true);
        toast.error(response.data.mesg);
      }
    },
  });
  
  const requiredFields = ["subSubj", "mainSubid"];

  const routeChangeEdit = (row: any) => {
    if (!permissionData?.isEdit) {
      toast.error("You don't have edit permission");
      return;
    }
    setIsEdit(true);
    setShowForm(true);
    formik.setFieldValue("subSubj", row.subSubj);
    formik.setFieldValue("mainSubid", row.mainSubid);
    setEditId(row.id);
  };

  const handleReset = () => {
    formik.resetForm();
    setIsEdit(false);
    if (!permissionData?.isAdd) {
      setShowForm(false);
    }
    setEditId(-1);
  };

  return (
    <>
      <Grid item lg={6} sm={6} xs={12} sx={{ marginTop: "3vh" }}>
        <Card
          style={{
            width: "100%",
            height: "50%",
            backgroundColor: "#E9FDEE",
            border: ".5px solid #FF7722 ",
            marginTop: "5px",
          }}
        >
          <Paper
            sx={{
              width: "100%",
              overflow: "hidden",
              "& .MuiDataGrid-colCell": {
                backgroundColor: `var(--grid-headerBackground)`,
                color: `var(--grid-headerColor)`,
                fontSize: 17,
                fontWeight: 900,
              },
            }}
            style={{ padding: "10px" }}
          >
            <ConfirmDialog />
            <Typography
              gutterBottom
              variant="h5"
              component="div"
              sx={{ padding: "20px" }}
              align="left"
            >
              {t("text.DocSubSubject")}
            </Typography>
            <Divider />

            <Box height={10} />
            <Stack direction="row" spacing={2} classes="my-2 mb-2">
              <Grid
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-around",
                  alignItems: "center",
                }}
              >
                {showForm && (
                  <form onSubmit={formik.handleSubmit}>
                    <Grid item xs={12} container spacing={3}>
                      <Grid item xs={5.5}>
                        <Autocomplete
                          disablePortal
                          id="combo-box-demo"
                          options={SubjectOption}
                          value={
                            SubjectOption.find(
                              (option: any) =>
                                option.value === formik.values.mainSubid
                            ) || null
                          }
                          fullWidth
                          size="small"
                          onChange={(event, newValue: any) => {
                            console.log(newValue?.value);
                            formik.setFieldValue("mainSubid", newValue?.value);
                            formik.setFieldTouched("mainSubid", true);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={
                                <span>
                                  {t("text.SelectSubject")} {""}
                                  {requiredFields.includes("mainSubid") && (
                                    <span
                                      style={{
                                        color: formik.values.mainSubid && formik.values.mainSubid !== -1
                                          ? "green"
                                          : "red",
                                      }}
                                    >
                                      *
                                    </span>
                                  )}
                                </span>
                              }
                            />
                          )}
                        />
                        {formik.touched.mainSubid && formik.errors.mainSubid ? (
                          <div style={{ color: "red", margin: "5px" }}>
                            {formik.errors.mainSubid}
                          </div>
                        ) : null}
                      </Grid>
                      <Grid item xs={5.5}>
                        <TextField
                          id="subSubj"
                          type="text"
                          label={
                            <span>
                              {t("text.SubSubject")} {""}
                              {requiredFields.includes("subSubj") && (
                                <span
                                  style={{
                                    color: formik.values.subSubj
                                      ? "green"
                                      : "red",
                                  }}
                                >
                                  *
                                </span>
                              )}
                            </span>
                          }
                          placeholder={t("text.SubSubject")}
                          value={formik.values.subSubj}
                          size="small"
                          name="subSubj"
                          fullWidth
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.subSubj && formik.errors.subSubj ? (
                          <div style={{ color: "red", margin: "5px" }}>
                            {formik.errors.subSubj}
                          </div>
                        ) : null}
                      </Grid>
                      <Grid item xs={1}>
                        <Button type="submit" variant="contained" size="large" style={{ backgroundColor: `var(--header-background)` }}>
                          {isEdit ? t("text.update") : t("text.save")}
                        </Button>
                      </Grid>
                      {/* <Grid item xs={1}>
                        <Button 
                          type="button" 
                          variant="contained" 
                          size="large" 
                          style={{ backgroundColor: "#F43F5E" }}
                          onClick={handleReset}
                        >
                          {t("text.reset")}
                        </Button>
                      </Grid> */}
                    </Grid>
                  </form>
                )}
              </Grid>
              <Typography
                variant="h6"
                component="div"
                sx={{ flexGrow: 1 }}
              ></Typography>
            </Stack>
            {isLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress />
              </div>
            ) : (
              <Box>
                <br></br>
                <div style={{ width: "100%", backgroundColor: `var(--grid-background)` }}>
                  <DataGrid
                    rows={rows}
                    columns={columns}
                    autoHeight
                    slots={{
                      toolbar: GridToolbar,
                    }}
                    rowSpacingType="border"
                    pagination={true}
                    pageSizeOptions={[5, 10, 25, 50, 100].map((size) => ({
                      value: size,
                      label: `${size}`,
                    }))}
                    initialState={{
                      pagination: { paginationModel: { pageSize: 5 } },
                    }}
                    slotProps={{
                      toolbar: {
                        showQuickFilter: true,
                      },
                    }}
                  />
                </div>
              </Box>
            )}
          </Paper>
        </Card>
      </Grid>
      <ToastApp />
    </>
  );
}